import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { FnrPopoverOption, FnrPopoverOptionsList } from "UI/FnrPopover2";

SingleGroupSelector.propTypes = {
  showGroupSelectList: PropTypes.bool,
  buttonRef: PropTypes.object,
  availableGroups: PropTypes.array,
  selectedGroupID: PropTypes.number,
  handleGroupSelect: PropTypes.func,
  setShowGroupSelectList: PropTypes.func,
};

export default function SingleGroupSelector({
  showGroupSelectList,
  buttonRef,
  availableGroups,
  selectedGroupID,
  handleGroupSelect,
  setShowGroupSelectList,
}) {
  return (
    <FnrPopoverOptionsList
      show={showGroupSelectList}
      buttonRef={buttonRef}
      onShouldClose={() => setShowGroupSelectList(false)}
      style={{ maxHeight: 550, overflow: "auto" }}
    >
      {availableGroups.map((group) => (
        <FnrPopoverOption
          key={group.groupID}
          disabled={selectedGroupID === group.groupID}
          data-cy={`groupName-${group.groupName}`}
          onClick={() => handleGroupSelect(group.groupID)}
        >
          <Wrapper $level={group.level}>
            <Img src={group.photo} alt={`${group.groupName} logo`} />
            <Name>{group.groupName}</Name>
          </Wrapper>
        </FnrPopoverOption>
      ))}
    </FnrPopoverOptionsList>
  );
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding-inline-start: ${({ $level }) => $level * 24}px;
`;
const Img = styled.img`
  width: 16px;
  height: 16px;
`;
const Name = styled.span`
  /* padding-inline-start: ${({ $level }) => $level * 16}px; */
`;
